import { useEffect } from 'react';
import { useTheme } from '@/components/theme-provider';

export default function FaviconHandler() {
  const { theme } = useTheme();

  useEffect(() => {
    const favicon = document.getElementById('favicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = theme === 'dark'
        ? '/favicon-branco.png'
        : '/favicon-gradiente.png';
    }
  }, [theme]);

  return null;
}
